import Pikaday from 'pikaday'
import 'jquery.flot'
import 'jquery.flot/jquery.flot.stack.js'
import 'jquery.flot/jquery.flot.time.js'
import 'jquery.flot.axislabels.js'
import 'jquery.flot.tooltip.js'

App.SalesReport = (function () {
  var initShow = function() {
    initCharts();
    watchTimePeriod();
    App.PurchaseOrder.initSubmitPOItemsOnChangeHandler();
  }

  var initIndex = function() {
    App.PurchaseOrder.initSubmitPOItemsOnChangeHandler();
  }

  var initProfitLoss = function() {
    if (!document.getElementById("profits_table")) return;
    $("#shop_list").select2();
    // pikaday
    var picker = new Pikaday({
      field: $('.pikaday')[0],
      format: "YYYY-MM-DD",
      onSelect: function() {
        var d = this.getMoment().format("YYYY-MM-DD");
        var el = $(this._o.field);
        document.location = el.data("url") + "?" + $.param({date: d})
      }
    });

    var cell_values = document.querySelectorAll('#profits_table td');
    var copiedValues = "";
    var copyCodeButton = document.querySelector(".copy-code-button");
    for(var i = 0; i<cell_values.length;i++){
      if(i%2!=0){
        if(copiedValues.length == 0){
          copiedValues += cell_values[i].innerText
        }else{
          copiedValues += "\n"+cell_values[i].innerText
        }
      }
    }

    function copyValues(){
      var copyarea = document.createElement("textarea");
      document.body.appendChild(copyarea);
      copyarea.value = copiedValues;
      copyarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyarea);
      copyCodeButton.innerHTML = ("Copied!");
      setTimeout(() => {
        copyCodeButton.innerHTML = ("Copy Values");
      }, 2000);
    } 
    copyCodeButton.addEventListener("click",function(){
      copyValues();
    });
    


    !function(){function t(e,r){if(!(this instanceof t))return new t(e,r);if(!e||"TABLE"!==e.tagName)throw new Error("Element must be a table");this.init(e,r||{})}var e=[],r=function(t){var e;return window.CustomEvent&&"function"==typeof window.CustomEvent?e=new CustomEvent(t):(e=document.createEvent("CustomEvent")).initCustomEvent(t,!1,!1,void 0),e},n=function(t){return t.getAttribute("data-sort")||t.textContent||t.innerText||""},o=function(t,e){return(t=t.trim().toLowerCase())===(e=e.trim().toLowerCase())?0:t<e?1:-1},i=function(t,e){return[].slice.call(t).find(function(t){return t.getAttribute("data-sort-column-key")===e})},s=function(t,e){return function(r,n){var o=t(r.td,n.td);return 0===o?e?n.index-r.index:r.index-n.index:o}};t.extend=function(t,r,n){if("function"!=typeof r||"function"!=typeof n)throw new Error("Pattern and sort must be a function");e.push({name:t,pattern:r,sort:n})},t.prototype={init:function(t,e){var r,n,o,i,s=this;if(s.table=t,s.thead=!1,s.options=e,t.rows&&t.rows.length>0)if(t.tHead&&t.tHead.rows.length>0){for(o=0;o<t.tHead.rows.length;o++)if("thead"===t.tHead.rows[o].getAttribute("data-sort-method")){r=t.tHead.rows[o];break}r||(r=t.tHead.rows[t.tHead.rows.length-1]),s.thead=!0}else r=t.rows[0];if(r){var a=function(){s.current&&s.current!==this&&s.current.removeAttribute("aria-sort"),s.current=this,s.sortTable(this)};for(o=0;o<r.cells.length;o++)(i=r.cells[o]).setAttribute("role","columnheader"),"none"!==i.getAttribute("data-sort-method")&&(i.tabindex=0,i.addEventListener("click",a,!1),null!==i.getAttribute("data-sort-default")&&(n=i));n&&(s.current=n,s.sortTable(n))}},sortTable:function(t,a){var d=t.getAttribute("data-sort-column-key"),u=t.cellIndex,l=o,h="",c=[],f=this.thead?0:1,b=t.getAttribute("data-sort-method"),g=t.getAttribute("aria-sort");if(this.table.dispatchEvent(r("beforeSort")),a||(g="ascending"===g?"descending":"descending"===g?"ascending":this.options.descending?"descending":"ascending",t.setAttribute("aria-sort",g)),!(this.table.rows.length<2)){if(!b){for(;c.length<3&&f<this.table.tBodies[0].rows.length;)(h=(h=(E=d?i(this.table.tBodies[0].rows[f].cells,d):this.table.tBodies[0].rows[f].cells[u])?n(E):"").trim()).length>0&&c.push(h),f++;if(!c)return}for(f=0;f<e.length;f++)if(h=e[f],b){if(h.name===b){l=h.sort;break}}else if(c.every(h.pattern)){l=h.sort;break}for(this.col=u,f=0;f<this.table.tBodies.length;f++){var w,m=[],v={},p=0,A=0;if(!(this.table.tBodies[f].rows.length<2)){for(w=0;w<this.table.tBodies[f].rows.length;w++){var E;"none"===(h=this.table.tBodies[f].rows[w]).getAttribute("data-sort-method")?v[p]=h:(E=d?i(h.cells,d):h.cells[this.col],m.push({tr:h,td:E?n(E):"",index:p})),p++}for("descending"===g?m.sort(s(l,!0)):(m.sort(s(l,!1)),m.reverse()),w=0;w<p;w++)v[w]?(h=v[w],A++):h=m[w-A].tr,this.table.tBodies[f].appendChild(h)}}this.table.dispatchEvent(r("afterSort"))}},refresh:function(){void 0!==this.current&&this.sortTable(this.current,!0)}},"undefined"!=typeof module&&module.exports?module.exports=t:window.Tablesort=t}();


    const table1 = document.getElementById('dropship-costs')
    const table2 = document.getElementById('warehouse-costs')

    let table1Array = [];
    let table2Array = [];

    let table1vals = table1.querySelectorAll('tr>td:nth-child(1)')
    let table2vals = table2.querySelectorAll('tr>td:nth-child(1)')

    table1vals.forEach((v)=>(table1Array.push(v.innerText)))
    table2vals.forEach((v)=>(table2Array.push(v.innerText)))

    let missingFromTable1 = table2Array.filter(i=>table1Array.indexOf(i)==-1);
    let missingFromTable2 = table1Array.filter(i=>table2Array.indexOf(i)==-1);

    if(missingFromTable1.length){
      missingFromTable1.forEach((e)=>table1.querySelector('tbody').innerHTML+='<tr><td>'+e+'</td><td>0</td></tr>');
    }

    if(missingFromTable2.length){
      missingFromTable2.forEach((e)=>table2.querySelector('tbody').innerHTML+='<tr><td>'+e+'</td><td>0</td></tr>');
    }

    setTimeout(function(){ new Tablesort(table1); new Tablesort(table2);}, 500);





  }

  var watchTimePeriod = function() {
    $('select#sales_report_time_period').on('change', function(e) {
      $('form#sales_report_time_period_form').submit();
    });
  }

  function initCharts() {
    var yaxis_options = $(".sales-chart:first").data('yaxis') || {};
    var options = {
      axisLabels: {
        show: true
      },
      grid: {
        show: true,
        hoverable: true,
        borderWidth: 1
        // backgroundColor: { colors: ["#EDF5FF", "#ffffff"] }
      },
      tooltip: {
        show: true,
        content: "%s: %y"
      },
      xaxis: {
        mode: "time",
        timeformat: "%b %Y",
        mode: "time",
        tickDecimals: 0,
        tickSize: [1, "month"],
        tickLength: 12,
        reserveSpace: true,
        color: "black"
      },
      yaxis: {
        color: "black",
        tickDecimals: 0
      },
      yaxes: [
        {position: "left", axisLabel: "Quantity Sold", min: yaxis_options.order.min, max: yaxis_options.order.max},
        {position: "right", axisLabel: "Inventory", min: yaxis_options.inventory.min, max: yaxis_options.inventory.max}
      ],
      legend: {
        show: false
      }
    };
    _($(".sales-chart")).forEach(function(e) {
      try {
        var inventoryData = $(e).data('inventory');
        var series =  [ { label: "Inventory", data: inventoryData, points: { show: true }, lines: { show: true }, yaxis: 2 } ];

        var orderQuantityData = $(e).data('quantity-ordered');
        _(orderQuantityData).forEach(function(e,key) {
          series.push( { label: key + " QTY Sold", data: e, stack: 1, bars: { show: true, align: "center", barWidth: 30 * 24 * 60 * 60 * 600 } } )
        });

        var numOrdersData = $(e).data('number-of-orders');
        _(numOrdersData).forEach(function(e,key) {
          series.push( { label: key + " NUM Orders", data: e, stack: 2, bars: { show: true, align: "center", barWidth: 30 * 24 * 60 * 60 * 600 / 2 } } )
        });

        $.plot(e, series, options);
      } catch (error) {
        console.log(error);
      }
    });
  }

  return {
    initIndex: initIndex,
    initProfitLoss: initProfitLoss,
    initShow: initShow
  }
})();

